import moment from 'moment'
import { IFileProps } from './File'
import { FileProperty, TalkTalker, Room } from '@/infrastructure/network/Monitaro/schema/models'

export interface IScheduledTalkProps {
  id?: string
  roomId: string
  talkerId: string | null
  talkerType: string | null
  message: string | null
  files?: FileProperty[] | null
  data?: File[] | null
  keeps?: IFileProps[] | null
  scheduledAt: string | null
  sentAt: string | null
  createdAt: string | null
  updatedAt: string | null
  talker?: TalkTalker
  room?: Room
}

export default class ScheduledTalkEntity {
  private _props: IScheduledTalkProps

  constructor(props?: IScheduledTalkProps | null) {
    this._props = EmptyScheduledTalkPropsFactory(props)
  }

  get props(): IScheduledTalkProps {
    return this._props
  }

  get clone(): IScheduledTalkProps {
    return structuredClone(this._props)
  }

  get id(): string | undefined {
    return this._props.id
  }

  get roomId(): string {
    return this._props.roomId
  }

  get talkerId(): string | null {
    return this._props.talkerId
  }

  get talkerType(): string | null {
    return this._props.talkerType
  }

  get message(): string | null {
    return this._props.message
  }

  get hasFile(): boolean {
    return !!this._props.files?.find((file) => file.filename)
  }

  get files(): FileProperty[] {
    return this._props.files ?? []
  }

  get talker(): TalkTalker | undefined {
    return this._props.talker
  }

  get room(): Room | undefined {
    return this._props.room
  }

  get scheduledAt(): string | null {
    return this._props.scheduledAt
  }

  get scheduledAtText(): string | null {
    return this._props.scheduledAt ? moment(this._props.scheduledAt).format('YYYY/MM/DD HH:mm') : null
  }

  get sentAt(): string | null {
    return this._props.sentAt
  }

  get isSent(): boolean {
    return !!this._props.sentAt
  }

  get createdAt(): string | null {
    return this._props.createdAt
  }

  get updatedAt(): string | null {
    return this._props.updatedAt
  }
}

export const EmptyScheduledTalkPropsFactory = (props?: Partial<IScheduledTalkProps> | null): IScheduledTalkProps => ({
  roomId: '',
  talkerId: null,
  talkerType: null,
  message: null,
  scheduledAt: null,
  sentAt: null,
  createdAt: null,
  updatedAt: null,
  ...props
})
